<style lang="less" scoped>
</style>
<template>
    <div>押题密卷</div>
</template>
<script>
    export default {};
</script>
